import styled from '@emotion/styled';
import {IconFilter} from '@travel-frontend/icons';

import {CountBadge} from '@/components/CountBadge';

type Props = {
  count: number;
};

const Wrapper = styled.span`
  position: relative;
  display: inline-block;
  width: 24px;
  height: 24px;
  vertical-align: middle;
`;

const StyledCountBadge = styled(CountBadge)`
  position: absolute;
  top: 6px;
  left: 8px;
  transform: translate(50%, -50%);
`;

export const FilterIconWithBadge = ({count}: Props) => {
  return (
    <Wrapper>
      <IconFilter />
      {count > 0 && (
        <StyledCountBadge
          count={count}
          backgroundColor="interactionSecondaryHover"
        />
      )}
    </Wrapper>
  );
};
